const situations = [
  {
    icon: 'ri-heart-pulse-line',
    title: 'Séance hebdo. de surveillance clinique',
    piege: 'Patient insulino-traité de +75 ans (30 min) : une cotation que les IDEL ont tendance à oublier.',
    avec: 'AMI 4, cotée 1 fois par semaine.',
    chiffre: 'Une cotation trop souvent oubliée',
  },
  {
    icon: 'ri-stack-line',
    title: 'Trois actes dans le même passage',
    piege: 'Le 3e acte est gratuit ?',
    avec: 'Règle 100 / 50 / 0 appliquée.',
    chiffre: 'Aucun acte sous-coté ni oublié',
  },
  {
    icon: 'ri-file-list-3-line',
    title: 'Cumuls & BSI',
    piege: 'BSI ou cumul d\u2019actes : le casse-tête de chaque tournée.',
    avec: 'CotIdel tranche selon le patient.',
    chiffre: 'Fini le casse-tête des cumuls',
  },
];

const stats = [
  { valeur: '100/50/0', label: 'la règle de cumul, appliquée d\u2019office' },
  { valeur: '5 €', label: 'de MCI déclenchée au bon passage' },
  { valeur: '0 €', label: 'de surveillance diabétique laissée gratuite' },
  { valeur: '94/100', label: 'score de conformité moyen' },
];

export default function WhySection() {
  return (
    <section id="pourquoi" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14 animate-on-scroll">
          <span className="text-xs font-semibold text-accent-600 uppercase tracking-wider">
            Concrètement
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mt-3 mb-4">
            Ce que ça change dans votre facturation
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Trois cas fréquents. CotIdel tranche à votre place.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12">
          {situations.map((s) => (
            <div
              key={s.title}
              className="bg-white border border-background-200/70 rounded-lg overflow-hidden flex flex-col animate-on-scroll"
            >
              <div className="p-6 flex-1">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
                  <i className={`${s.icon} text-xl`}></i>
                </div>
                <h3 className="text-base font-bold font-heading text-foreground-950 mb-4">{s.title}</h3>

                <p className="text-sm text-foreground-500 mb-3">{s.piege}</p>

                <p className="text-sm font-semibold text-primary-600 flex items-center gap-1.5">
                  <i className="ri-check-line"></i>
                  {s.avec}
                </p>
              </div>
              <div className="px-6 py-3 bg-accent-50 border-t border-accent-200/40">
                <span className="text-sm font-bold text-accent-700">{s.chiffre}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Chiffres réels */}
        <div className="bg-primary-500 rounded-lg p-6 md:p-8 grid grid-cols-2 md:grid-cols-4 gap-6 animate-on-scroll">
          {stats.map((st) => (
            <div key={st.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold font-heading text-white">{st.valeur}</div>
              <div className="text-xs text-white/70 mt-1">{st.label}</div>
            </div>
          ))}
        </div>

        {/* Sérénité */}
        <div className="mt-12 bg-background-100 border border-background-200/70 rounded-lg p-6 md:p-8 flex flex-col md:flex-row items-center gap-5 animate-on-scroll">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
            <i className="ri-moon-clear-line text-xl"></i>
          </div>
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed text-center md:text-left">
            <strong className="text-foreground-950">Plus besoin de trancher seul.</strong>{' '}
            Vous cotez juste, vous dormez tranquille.
          </p>
        </div>
      </div>
    </section>
  );
}